import { render } from "./CIS-List-Landing-Featured.vue?vue&type=template&id=3357d6d9&scoped=true"
import script from "./CIS-List-Landing-Featured.vue?vue&type=script&lang=js"
export * from "./CIS-List-Landing-Featured.vue?vue&type=script&lang=js"

import "./CIS-List-Landing-Featured.vue?vue&type=style&index=0&id=3357d6d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3357d6d9"]])

export default __exports__